import {Validator} from './validator';

export class AddonValidator implements Validator {
    async validate(validationContext: any) {
        return Promise.resolve(!!validationContext.length);
    }
}
